// export default {
//   baseURL
// }
class RequestDefault {
  constructor () {
    const origin = location.origin
    if (process.env.NODE_ENV === 'development') {
      // https://live-cast-app-stag.zowoyoo.com
      this.baseURL = 'https://live-cast-app-stag.zowoyoo.com'
    } else if (origin === 'https://gtpw-ui-ts-stag.zowoyoo.com') {
      this.baseURL = 'https://live-cast-app-stag.zowoyoo.com'
    } else {
      this.baseURL = 'https://live-cast-app.zowoyoo.com'
    }
  }

  public baseURL = ''

  public authToken = 'https://uw-auth-center.zowoyoo.com'
}

const Default = new RequestDefault()
export default Default
